module.exports = __webpack_public_path__ + "static/media/adventure-game.0539cb47.jpeg";